/**
 *
 * Resoource
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, Redirect, Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { selectPermissions } from '../Authorization/slice/selectors';
import Harvest from './pages/Harvest/Harvest';
import ResourceAllocation from './pages/ResourceAllocation/ResourceAllocation';
import UsedResourcesPage from './pages/UsedResourcesPage/UsedResourcesPage';

interface IProps {}

export const Resource: FC<IProps> = props => {
  const { resourceAdministration } = useSelector(selectPermissions);
  if (resourceAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <>
      <Switch>
        <Route
          path={RouteConstants.usedResource.index}
          component={UsedResourcesPage}
        />
        <Route
          path={RouteConstants.resource.harvestCulture}
          component={Harvest}
        />
        <Route path={RouteConstants.resource.harvest} component={Harvest} />

        <Route
          path={RouteConstants.resource.resourceAllocationUsedResourceActionLog}
          component={ResourceAllocation}
        />

        <Route
          path={RouteConstants.resource.resourceAllocationTaskCategory}
          component={ResourceAllocation}
        />

        <Route
          path={RouteConstants.resource.resourceAllocation}
          component={ResourceAllocation}
        />

        <Route
          exact
          path={RouteConstants.resource.index}
          render={props => (
            <Redirect
              to={generatePath(RouteConstants.company.list, {
                envId: Number(props.match.params.envId),
              })}
            />
          )}
        />
      </Switch>
    </>
  );
};
